// extracted by mini-css-extract-plugin
export default {"listItemsContainer":"ListItems_listItemsContainer__kBxhw","list_type_image":"ListItems_list_type_image__VBBCo","list_type_text":"ListItems_list_type_text__cCRAe"};